<template>
  <div class="border-bottom">

    <!-- ROW -->
    <div
      class="d-flex justify-content-between align-items-center py-2 px-2 folder-row"
      @click="onToggle"
    >
      <div class="d-flex align-items-center">
        <i :class="icon" class="me-3 fs-5"></i>

        <!-- 🔥 Nếu là file/pdf → A, còn lại → SPAN -->
        <a
          v-if="isFile"
          :href="item.link"
          target="_blank"
          class="text-decoration-none"
          @click.stop
        >
          {{ item.name || item.title }}
        </a>

        <span v-else>{{ item.name }}</span>
      </div>

      <!-- caret folder -->
      <i
        v-if="item.type === 'folder'"
        :class="expanded[item.id] ? 'fa fa-chevron-circle-up' : 'fa fa-chevron-circle-down'"
        class="text-secondary"
      ></i>
    </div>

    <!-- CHILDREN -->
    <div v-if="isOpen" class="ms-4 mt-2 mb-2">

      <FolderItem
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :expanded="expanded"
        @toggle="$emit('toggle', $event)"
      />
    </div>

  </div>
</template>

<script>
export default {
  name: "FolderItem",

  props: {
    item: Object,
    expanded: Object
  },

  computed: {
    isOpen() {
      return this.expanded[this.item.id];
    },

    /** PDF hoặc file => là file */
    isFile() {
      return this.item.type === "pdf" || this.item.type === "file";
    },

    icon() {
      if (this.item.type === "pdf") return "fa fa-file-pdf-o text-danger";
      if (this.item.type === "file") return "fa fa-file-text-o text-secondary";
      return "fa fa-folder-open-o text-warning";
    }
  },

  methods: {
    onToggle() {
      if (this.item.type === "folder") {
        this.$emit("toggle", this.item.id);
      }
    }
  }
};
</script>

<style scoped>
.folder-row:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}
</style>
